import { createBrowserRouter } from 'react-router-dom';
import MainLayout from '../components/layout/MainLayout/MainLayout';
import PrivatePage from '../components/layout/MainLayout/PrivatePage';
import ROUTER from './Routers';
import NotFound from '../pages/NotFound/NotFound';
import DesignerPage from '../pages/DesignerPage/DesignerPage';
import HomePage from '../pages/HomePage/HomePage';
import PaymentPage from '../pages/PaymentPage/PaymentPage';
import CartPage from '../pages/CartPage/CartPage';
import CenterSupportPage from '../pages/CenterSupportPage/CenterSupportPage';
import SlugCenterSupportPage from '../pages/CenterSupportPage/[slug]';
import { SlugAccountPage } from '../pages/AccountPage/[slug]';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import ActiveAccount from '../pages/ActiveAccount/ActiveAccount';
import LinkExperied from '../pages/LinkExperied/LinkExperied';
import AboutUs from '../pages/AboutUs/AboutUs';
import ConfirmDelete from '../pages/ConfirmedDelete/ConfirmDelete';
import ConfirmedChangeEmail from '../pages/ConfirmedChangeEmail/ConfirmedChangeEmail';
import CMSLayout from '../components/layout/MainLayout/CMSLayout';
import SalesPage from '../pages/cms/SalesPage/SalesPage';
import ProductsPage from '../pages/cms/ProductsPage/ProductsPage';
import ProductInventoryPage from '../pages/cms/ProductInventoryPage/ProductInventoryPage';
import DetailOrderPage from '../pages/cms/DetailOrderPage/DetailOrderPage';
import DesignerPageLayout from '../pages/DesignerPage/DesignerPageLayout';
import CategoryPage from '../pages/CategoryPage/CategoryPage';
import DetailProductPageUpgrade from '../pages/DetailProductPage/DetailProductPageUpgrage';
import SubLayout from '../components/layout/MainLayout/SubLayout';
import { redirect } from 'react-router-dom';
import DetailUserPage from '../pages/cms/CustomersPage/DetailUserPage';
import QuotationPage from '../pages/QuotationPage/QuotationPage';
import CreateProductInventoryPage from '../pages/cms/ProductInventoryPage/CreateProductInventoryPage';
import UpdateProductInventoryPage from '../pages/cms/ProductInventoryPage/UpdateProductInventoryPage';
import NewCustomerPage from '../pages/cms/CustomersPage/NewCustomerPage';
import DesignCustomersPage from '../pages/cms/DesignCustomersPage/DesignCustomersPage';

const router = createBrowserRouter([
  {
    path: '',
    element: <MainLayout />,
    errorElement: <NotFound />,
    children: [
      {
        index: true,
        path: ROUTER.HOMEPAGE,
        element: <HomePage />,
        handle: { titleKey: 'Home' },
      },
      {
        path: ROUTER.PRODUCT_DETAIL + '/:id',
        element: <DetailProductPageUpgrade />,
        handle: { titleKey: 'Product Details' },
      },
      {
        path: ROUTER.CENTER_SUPPORT,
        element: <CenterSupportPage />,
        handle: { titleKey: 'Support' },
      },
      {
        path: ROUTER.RESET_PASSWORD + '/:token',
        element: <ResetPassword />,
        handle: { titleKey: 'Reset password' },
      },
      {
        path: ROUTER.ACTIVE_ACCOUNT + '/:token',
        element: <ActiveAccount />,
        handle: { titleKey: 'Activate account' },
      },
      {
        path: ROUTER.CONFIRMED_DELETE,
        element: <ConfirmDelete />,
        handle: { titleKey: 'Confirm account deletion' },
      },
      {
        path: ROUTER.CONFIRMED_CHANGE_EMAIL,
        element: <ConfirmedChangeEmail />,
        handle: { titleKey: 'Confirm email change' },
      },
      {
        path: ROUTER.LINK_EXPIRED,
        element: <LinkExperied />,
        handle: { titleKey: 'Link expired' },
      },
      {
        path: ROUTER.ABOUT_US,
        element: <AboutUs />,
        handle: { titleKey: 'About us' },
      },
      {
        path: ROUTER.CATEGORY + '/:id?',
        element: <CategoryPage />,
        handle: { titleKey: 'Category' },
      },
      {
        path: ROUTER.QUOTATION,
        element: <QuotationPage />,
        handle: { titleKey: 'Quotation' },
      },
    ],
  },
  {
    path: '',
    element: <PrivatePage />,
    // errorElement: <NotFound />,
    children: [
      // { path: ROUTER.ACCOUNT + '/:slug', element: <SlugAccountPage /> },
      {
        path: ROUTER.ACCOUNT + '/:slug?/:id?',
        element: <SlugAccountPage />,
        handle: { titleKey: 'Account' },
      },
      {
        path: ROUTER.PAYMENT,
        element: <PaymentPage />,
        handle: { titleKey: 'Payment' },
      },
      {
        path: ROUTER.CART,
        element: <CartPage />,
        handle: { titleKey: 'Cart' },
      },
    ],
  },
  {
    path: ROUTER.CMS,
    element: <CMSLayout />,
    // errorElement: <NotFound />,
    children: [
      { index: true, loader: () => redirect(ROUTER.CMS + ROUTER.ORDER) },
      {
        path: ROUTER.CMS + ROUTER.CUSTOMER,
        element: <NewCustomerPage />,
        handle: { titleKey: 'Accounts' },
      },
      {
        path: ROUTER.CMS + ROUTER.CUSTOMER + '/:id',
        element: <DetailUserPage />,
        handle: { titleKey: 'Account Details' },
      },
      {
        path: ROUTER.CMS + ROUTER.DESIGN_CUSTOMER,
        element: <DesignCustomersPage />,
        handle: { titleKey: 'Customers' },
      },
      {
        path: ROUTER.CMS + ROUTER.PRODUCT,
        element: <ProductsPage />,
        handle: { titleKey: 'Products' },
      },
      {
        path: ROUTER.CMS + ROUTER.PRODUCT_INVENTORY,
        element: <ProductInventoryPage />,
        handle: { titleKey: 'Product Inventory' },
      },
      {
        path: ROUTER.CMS + ROUTER.CREATE_PRODUCT_INVENTORY,
        element: <CreateProductInventoryPage />,
        handle: { titleKey: 'Create Product Inventory' },
      },
      {
        path: ROUTER.CMS + ROUTER.UPDATE_PRODUCT_INVENTORY + '/:id',
        element: <UpdateProductInventoryPage />,
        handle: { titleKey: 'Update Product Inventory' },
      },
      {
        path: ROUTER.CMS + ROUTER.ORDER,
        element: <SalesPage />,
        handle: { titleKey: 'Orders' },
      },
      {
        path: ROUTER.CMS + ROUTER.ORDER + '/:id',
        element: <DetailOrderPage />,
        handle: { titleKey: 'Order Details' },
      },
    ],
  },
  {
    path: '',
    element: <SubLayout />,
    children: [
      {
        path: ROUTER.CENTER_SUPPORT + '/:slug',
        element: <SlugCenterSupportPage />,
        handle: { titleKey: 'Support Details' },
      },
    ],
  },
  {
    path: '/design/:type',
    element: <DesignerPageLayout />,
    private: false,
    isChild: false,
    handle: { titleKey: 'Design' },
  },

  {
    path: '*',
    element: <NotFound />,
    private: false,
    handle: { titleKey: 'Page not found' },
  },
]);

export default router;
